module.exports = __webpack_public_path__ + "img/costa_rica.1e6a03d.webp";